


/* ── Popup success state ─────────────────────────────────────────────────────
   Shopify redirects back with ?customer_posted=true after a newsletter signup.
   Show the popup immediately instead of waiting out its 5s delay: the shopper
   just acted, and the one-click "Apply my 10% off" button lives in that success
   state. Also deliberately bypasses the 7-day dismiss cookie — that cookie
   should hide an unsolicited popup, not a person's own confirmation.

   Lives here, not in notification-popup.js, so a Wonder theme update cannot
   drop it. Removing .hidden early is safe: the vendor's own setTimeout later
   removes it again, which is a no-op. */
document.addEventListener('DOMContentLoaded', function () {
  if (location.search.indexOf('customer_posted=true') === -1) return;
  var popup = document.querySelector('.not-pu-section');
  if (!popup) return;
  popup.classList.remove('hidden');
  popup.classList.add('wt-popup-fade-in');
  // Lets custom.css swap the pre-signup copy for the success copy. The heading
  // and paragraph are theme-editor blocks rendered before the form, so Liquid
  // cannot see form.posted_successfully? at that point — hence a class here.
  popup.classList.add('sh-popup--success');
});


/* ── Popup: click the backdrop to dismiss ────────────────────────────────────
   The dim + blur behind the popup is a ::before on .not-pu-section itself,
   not a separate overlay div — so there is no element to attach this to.
   That turns out to be the easy case: a click on a pseudo-element is
   attributed to its host, so every backdrop click arrives here as a click on
   .not-pu-section whose target is the section rather than anything inside the
   card. `closest('.newsletter')` is what separates the two.

   Dismissing REUSES the theme's own close button rather than re-implementing
   it. Closing sets a 7-day cookie, and a backdrop click that only hid the
   popup would leave it to reappear on the next page view — more annoying than
   having no backdrop click at all. Clicking the button keeps one definition of
   "dismissed", and keeps working if the vendor changes what that means.

   Safe to fire blind: the popup is only visible after the custom element's own
   setTimeout, which runs after it attached that click handler.

   Lives in custom.js so a Wonder theme update cannot drop it. */
document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('.not-pu-section');
  if (!popup) return;

  popup.addEventListener('click', function (e) {
    /* Inside the card — a field, the button, the image. Not a dismissal. */
    if (e.target.closest('.newsletter')) return;
    var close = popup.querySelector('.newsletter__close-btn');
    if (close) close.click();
  });
});


/* ── Pickup drawer: one card per store ───────────────────────────────────────
   Built to match /pages/store exactly, because that is where this brand already
   decided how a Sihaté shop is presented: white card at 16px radius, the
   address in #173B3BD9 at 15px/1.7, then bold "Hours:" and "Phone:" labels,
   then the orange GET DIRECTIONS button. Values in custom.css, copied from
   `.sh-stores__card` / `__text` / `__btn`, not approximated.

   The address, hours and phone strings mirror the blocks in
   templates/page.store.json. Shopify's own `format_address` is not used: it
   stacks four lines, appends a state code and prints the country, which is a
   postal format, not something to read on a card. If a store's details change
   on the store page, change them here too.

   INJECTED ON OPEN, NEVER ON LOAD. Seven store photos on every product view,
   for a panel most shoppers never open, is the reel-poster mistake that starved
   this store's Meta pixel. Nothing is fetched until the button is clicked.

   Lives in custom.js so a Wonder theme update cannot drop it. */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0606/8699/1558/files/';
  var STORES = {
    'Sihaté Bangi': {
      img: 'sihate-bangi-1a.jpg', hours: '10am - 7pm', tel: '+6010-959 8779',
      addr: 'UG-02, Sunway Gandaria, 2, Jalan Pusat Bandar, Seksyen 9, 43650 Bandar Baru Bangi, Selangor.' },
    'Sihaté Taman Melati': {
      img: 'sihate-taman-melati-1c.jpg', hours: '10am - 10pm', tel: '+6011-6063 8779',
      addr: 'Jalan Melati Utama 4, Taman Melati Utama, 53100 Kuala Lumpur.' },
    'Sihaté Shah Alam': {
      img: 'sihate-shah-alam-1b.jpg', hours: '10am - 7pm', tel: '+6014-364 5611',
      addr: 'Pusat Komersial, 31, Jalan Plumbum P7/P, Seksyen 7, 40000 Shah Alam, Selangor.' },
    'Sihaté Puncak Alam': {
      img: 'sihate-puncak-alam-1a.jpg', hours: '10am - 7pm', tel: '+6012-956 8779',
      addr: '3B, 26, Persiaran Eco Grandeur 1, 42300 Puncak Alam, Selangor.' },
    'Sihaté Kota Bharu': {
      img: 'sihate-kota-bharu-1c.jpg', hours: '10am - 7pm', tel: '+6011-6117 8779',
      addr: '782-J, Jalan Temenggong, Bandar Kota Bharu, 15000 Kota Bharu, Kelantan.' },
    'Sihaté Pasir Tumboh': {
      img: 'sihate-taman-pasir-tumboh-1a.jpg', hours: '9am - 6pm, closed Friday', tel: '+6011-5406 5456',
      addr: 'PT 3925-1-1 Taqwa A1, Bandar Satelit Islam, Pasir Tumbuh, 16150 Kota Bharu, Kelantan.' },
    'Sihaté Johor Bahru': {
      img: 'sihate-store-jb.jpg', hours: '10am - 7pm', tel: '+6011-6513 8779',
      addr: '15-01, Jalan Padi Emas 1/5, Bandar Baru Uda, 81200 Johor Bahru, Johor.' }
  };

  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

  function decorate(scope) {
    var rows = (scope || document).querySelectorAll('.pickup-availability-list__item');
    for (var i = 0; i < rows.length; i++) {
      var li = rows[i];
      if (li.dataset.shPickup) continue;
      var h = li.querySelector('h3');
      if (!h) continue;
      var name = h.textContent.trim();
      var st = STORES[name];
      if (!st) { li.dataset.shPickup = '1'; continue; }

      var status = li.querySelector('.pickup-availability-preview');
      /* The same sentence on all seven cards; only the wait varies. */
      var wait = status ? (status.textContent.match(/ready in ([^,.]+)/i) || [])[1] : '';

      var card = document.createElement('div');
      card.className = 'sh-store-card';

      /* The photo gets a wrapper so the wait label can sit on it. */
      var media = document.createElement('div');
      media.className = 'sh-store-card__media';
      card.appendChild(media);

      var img = new Image();
      img.src = CDN + st.img + '?width=280';
      img.alt = '';
      /* No loading="lazy": the drawer sits off-canvas at translateX(100%), so
         the browser defers these forever and the card renders an empty box.
         Opening the drawer is the deferral. */
      img.decoding = 'async';
      img.className = 'sh-store-card__img';
      media.appendChild(img);

      var body = document.createElement('div');
      body.className = 'sh-store-card__body';
      /* ONE flowing block: name, address, hours, phone. Bold is the only
         separation - no heading row, no line breaks. Four rows collapse into one
         wrapped paragraph, which is most of the card's height back.

         A div holding an INLINE h3, not a <p>: renders identically to a
         paragraph but keeps the store name a real heading, so a screen-reader
         user can still jump between the seven stores. An <h3> inside a <p> is
         invalid HTML, which is the only reason this is not literally a <p>. */
      body.innerHTML =
        '<div class="sh-store-card__text">' +
          '<h3 class="sh-store-card__name">' + esc(name) + '</h3> - ' + esc(st.addr) +
          ' <strong>Hours:</strong> ' + esc(st.hours) +
          '<span class="sh-store-card__sep"> &middot; </span>' +
          '<strong>Phone:</strong> ' + esc(st.tel) +
        '</div>';
      if (status && status.textContent.trim()) {
        /* A label on the photo, styled like the "Save %" pill, so the wait
           costs no row of its own. The vendor tick is dropped: the pill is a
           label and, like the Save pill, carries no icon.

           The unit is abbreviated rather than hardcoded, so the label still
           follows Shopify's pickup-time setting — change it to two hours and
           this reads "Ready in 2h". */
        var short = (wait || '').trim()
          .replace(/\s*hours?\b/i, 'h')
          .replace(/\s*days?\b/i, 'd')
          .replace(/\s*minutes?\b/i, 'm');
        status.className = 'sh-store-card__status';
        status.textContent = short ? 'Ready in ' + short : 'Pickup available';
        media.appendChild(status);
      }
      card.appendChild(body);
      li.innerHTML = '';
      li.appendChild(card);
      li.dataset.shPickup = '1';
    }
  }

  /* The drawer prints `product_variant.price` alone, so a variant on offer
     showed RM95.00 with no sign of the RM129.00 it is down from — the one place
     on the site where the saving is invisible.

     The numbers are MIRRORED FROM THE PRODUCT PAGE'S OWN PRICE BLOCK rather
     than rebuilt: that block already reflects the selected variant, already
     formats money for the store's currency, and already decides whether the
     saving reads as a percentage or an amount. Reading it keeps the drawer
     honest for free, and cannot disagree with the page behind it. */
  function mirrorPrice() {
    var h2s = document.querySelectorAll('pickup-availability-drawer .product-info h2');
    if (h2s.length < 2) return;
    var target = h2s[h2s.length - 1];
    if (target.dataset.shPrice) return;

    var src = document.querySelector('.wt-product__main .price');
    if (!src) return;
    var was = src.querySelector('.price-item--lower');
    var now = src.querySelector('.price-item--sale');
    var save = src.querySelector('.price-item--percent');
    /* No compare-at, nothing to show — leave the plain price alone. */
    if (!was || !now || was.textContent.trim() === now.textContent.trim()) return;

    target.innerHTML =
      '<s class="sh-pickup-price__was">' + esc(was.textContent.trim()) + '</s>' +
      '<span class="sh-pickup-price__now">' + esc(now.textContent.trim()) + '</span>' +
      (save ? '<span class="sh-pickup-price__save">' + esc(save.textContent.trim()) + '</span>' : '');
    target.classList.add('sh-pickup-price');
    target.dataset.shPrice = '1';
  }

  /* The drawer's product image never loaded. Two faults, both vendor:

     1. `src` is built from `product_variant.featured_image | image_url`, and
        these variants are quantity tiers with no image of their own — so the
        filter runs on nil and Shopify writes the ERROR STRING into src:
        "pickup-availability line 82): invalid url input".
     2. `loading="lazy"` on an element inside a drawer parked off-canvas at
        translateX(100%), which the browser never judges near the viewport, so
        it would defer forever even with a valid URL.

     The srcset's last candidate is the PRODUCT image and is valid, so it is
     promoted to src at a retina width and the lazy attribute dropped. Fixed
     here rather than in the section so a theme update cannot undo it. */
  function fixHeaderImage() {
    var img = document.querySelector('pickup-availability-drawer .product-image img');
    if (!img || img.dataset.shImg) return;
    var parts = (img.getAttribute('srcset') || '').trim().split(',');
    var last = parts.length ? parts[parts.length - 1].trim().split(/\s+/)[0] : '';
    if (/^(https?:)?\/\//.test(last)) {
      img.removeAttribute('srcset');
      img.removeAttribute('loading');
      img.src = last.replace(/width=\d+/, 'width=240');
    }
    img.dataset.shImg = '1';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#ShowPickupAvailabilityDrawer');
    if (!btn) return;
    decorate();
    mirrorPrice();
    fixHeaderImage();
    var drawer = document.querySelector('pickup-availability-drawer');
    if (drawer && !drawer.dataset.shObserved) {
      new MutationObserver(function () { decorate(drawer); mirrorPrice(); fixHeaderImage(); }).observe(drawer, { childList: true, subtree: true });
      drawer.dataset.shObserved = '1';
    }
  });
})();


/* ── Cart cross-sell: remember that it was collapsed ─────────────────────────
   "Add to your parcel" collapses by toggling a class, but the drawer re-renders
   its whole HTML from the server on every cart change — add an item, change a
   quantity — and the fresh markup carries `settings.cross_sells_collapsed`
   again. So the block a shopper just dismissed reopened on their next click.

   SESSION storage, not local. Collapsing means "not now", not "never show me
   this again": persisting it forever would let one dismissal permanently
   remove the cross-sell for that customer, which is the opposite of what the
   block is for. A new visit starts open again.

   Nothing here touches the Liquid. The snippet's inline onclick still does the
   toggling; this listens on the document, so it fires after that handler and
   simply records the state it produced — and keeps working when the drawer
   replaces the element it was attached to.

   Lives in custom.js so a Wonder theme update cannot drop it. */
(function () {
  var KEY = 'sh-cross-sell-collapsed';
  var BLOCK = '.wt-cart__cross-sell';
  var COLLAPSED = 'wt-cart__cross-sell--collapsed';

  function apply(root) {
    if (sessionStorage.getItem(KEY) !== '1') return;
    var blocks = (root || document).querySelectorAll(BLOCK);
    for (var i = 0; i < blocks.length; i++) blocks[i].classList.add(COLLAPSED);
  }

  /* Bubble phase, so the snippet's own onclick has already toggled the class
     and this reads the result rather than trying to predict it. */
  document.addEventListener('click', function (e) {
    var heading = e.target.closest && e.target.closest('.wt-cart__cross-sell__heading');
    if (!heading) return;
    var block = heading.closest(BLOCK);
    if (!block) return;
    if (block.classList.contains(COLLAPSED)) sessionStorage.setItem(KEY, '1');
    else sessionStorage.removeItem(KEY);
  });

  /* The drawer swaps its innerHTML, so there is no event to hook that every
     cart mutation is guaranteed to fire. Watching for the element to reappear
     is the one approach that does not depend on the theme's internals. Scoped
     to the drawer, and the callback is a single class check. */
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    apply(drawer);
    new MutationObserver(function () { apply(drawer); })
      .observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
